import { render, staticRenderFns } from "./updateSchool.vue?vue&type=template&id=034979b6&scoped=true"
import script from "./updateSchool.vue?vue&type=script&lang=js"
export * from "./updateSchool.vue?vue&type=script&lang=js"
import style0 from "./updateSchool.vue?vue&type=style&index=0&id=034979b6&prod&lang=scss&scoped=true"
import style1 from "./updateSchool.vue?vue&type=style&index=1&id=034979b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034979b6",
  null
  
)

export default component.exports